import React from "react";
import { useApp } from "@/context/AppContext";
import { Reveal } from "@/components/Reveal";

export default function Process() {
  const { t } = useApp();
  return (
    <section id="process" className="relative py-28 lg:py-40 bg-background" data-testid="process-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[380px_1fr] gap-12 lg:gap-20">
        <div className="lg:sticky lg:top-28 h-max">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05]">{t.process.title}</h2>
          </Reveal>
        </div>
        <div className="divide-y divide-border border-t border-border">
          {t.process.steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.06}>
              <div className="py-10 grid grid-cols-[64px_1fr] gap-6 group" data-testid={`process-step-${i}`}>
                <span className="font-mono text-sm text-brass pt-2">{s.n}</span>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl mb-3 group-hover:text-cyan transition-colors">{s.t}</h3>
                  <p className="text-muted-foreground leading-relaxed max-w-xl">{s.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
